import Lenis from 'lenis';
import gsap from 'gsap';
import * as popper from '@popperjs/core';
import * as bootstrap from 'bootstrap';

import initHome from './components/home';
import initHomeHeroCarousel from './components/home-hero-carousel';

import initFeatureBlocks from './components/feature-block';
import initStatsBlocks from './components/stats-block';
import initTextAnims from './components/text-anims';
import initFunFacts from './components/fun-facts';
import initCrossSell from './components/cross-sell-block';
import initItemCards from './components/item-cards';
import initTicketsBlocks from './components/tickets-block';
import initGalleries from './components/gallery-block';
import initReviews from './components/reviews-block';
import initDidYouKnowBlocks from './components/did-you-know-block';
import initShare from './components/share';
import initHeader from './components/header';
import initPlayer from './components/player';
import initInstagramFeedBlock from './components/instagram-feed-block';
import initTabs from './components/tabs-content';
import initLoadMore from './components/load-more';
import initGravityFormsA11y from './components/gravity-forms-a11y';
import initCountdownWidgets from './components/countdown-widget';

// Styles
import '../scss/styles.scss';
import 'swiper/swiper-bundle.css';

// -----------------------------
// Lenis (smooth scroll)
// -----------------------------
const lenis = new Lenis({ smoothWheel: true });

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

// -----------------------------
// Page init
// -----------------------------
window.initTextAnims = initTextAnims;

function updateContainerWidthVar() {
  const fc = document.querySelector('.footer .container');
  if (fc) {
    document.documentElement.style.setProperty(
      '--container-width',
      fc.offsetWidth + 'px'
    );
  }
}

function initPage() {
  // Pages
  if (document.querySelector('.home-hero')) initHome();
  if (document.querySelector('.home-hero--carousel')) initHomeHeroCarousel();

  // Components
  if (document.querySelector('.feature-block')) initFeatureBlocks();
  if (document.querySelector('.stats-block')) initStatsBlocks();
  if (document.querySelector('.fun-facts')) initFunFacts();
  if (document.querySelector('.cross-sell-block')) initCrossSell();
  if (document.querySelector('.item-cards')) initItemCards();
  if (document.querySelector('.tickets-block')) initTicketsBlocks();
  if (document.querySelector('.gallery')) initGalleries();
  if (document.querySelector('.reviews-block')) initReviews();
  if (document.querySelector('.did-you-know-block')) initDidYouKnowBlocks();
  if (document.querySelector('.instagram-feed-block')) initInstagramFeedBlock();
  if (document.querySelector('.mod-tabs-content')) initTabs();
  if (document.querySelector('.countdown-widget')) initCountdownWidgets();

  // Load more & filters (archive pages)
  initLoadMore();

  // Share
  initShare();

  // Gravity Forms accessibility (focus + ARIA)
  initGravityFormsA11y();

  // Text anims
  initTextAnims();

  // Container width var (kept in sync on resize)
  updateContainerWidthVar();
}

// -----------------------------
// Boot
// -----------------------------
initHeader();
initPage();
window.addEventListener('resize', updateContainerWidthVar, { passive: true });

window.addEventListener('DOMContentLoaded', () => {
  window.playerInstance = null;
  initPlayer();
});
